// app/javascript/controllers/post_import_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["json", "preview"]

  populate() {
    let data
    try {
      data = JSON.parse(this.jsonTarget.value)
    } catch (e) {
      this.previewTarget.textContent = "Invalid JSON"
      this.previewTarget.classList.add("text-red-500")
      return
    }

    const set = (name, value) => {
      const el = document.querySelector(`[name="post[${name}]"]`)
      if (!el) return
      if (el.type === "checkbox") {
        el.checked = !!value
      } else {
        el.value = value ?? ""
      }
    }

    set("title",            data.title)
    set("slug",             data.slug)
    set("body",             data.body)
    set("author",           data.author)
    set("series",           data.series)
    set("series_order",     data.series_order)
    set("cover_image",      data.cover_image)
    set("og_image",         data.og_image)
    set("meta_title",       data.meta_title)
    set("meta_description", data.meta_description)
    set("published",        data.published)
    set("featured",         data.featured)

    // Tags — comma-separated string into the tags field
    if (data.tags) {
      const tags = Array.isArray(data.tags) ? data.tags.join(", ") : data.tags
      const tagsEl = document.querySelector(`input[name="post[tags][]"]`)
      if (tagsEl) tagsEl.value = tags
    }

    // Trigger EasyMDE update if body changed
    if (window.easyMDE && data.body) {
      window.easyMDE.value(data.body)
    }

    this.previewTarget.textContent = "✓ Fields populated — review and save"
    this.previewTarget.classList.remove("text-red-500")
    this.previewTarget.classList.add("text-green-600")
  }
}